<script>
    import {getStyleValue} from '../../Common/tools';
    import ImageHeader from "./ImageHeader.svelte";
    import Menu from "./Menu.svelte";

    export let data, globalStyle;
</script>
<tr>
    <th>
        <table>
            <tr>
                <ImageHeader data={data} isChild={true} />
                <th class="column mobile-12" style="line-height: 45px; padding-left: 10px; padding-right: 40px;"
                    width="{getStyleValue(globalStyle.width, 600) - data.style.width}">
                    <div align="right">
                        <Menu data={data} clz="menu component-right mobile-vertical mobile-margin-top"/>
                    </div>
                </th>
            </tr>
        </table>
    </th>
</tr>
